module.exports = __webpack_public_path__ + "static/media/pavo real.4a09d9b7.png";